module.exports = __webpack_public_path__ + "afcdf66ca96776c261dfe3bb470dd28c.png";